import { FC } from "react";

import {
	FieldLayout,
	LabelPosition,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { RHookFormNumericFormatTextField } from "../../TaxSlipDataInput/RHookFormNumericFormatTextField";
 
interface ICSSTSetupFieldsPanel {}
export const CSSTSetupFieldsPanel: FC<ICSSTSetupFieldsPanel> = ({}) => {
	return (
		<div style={{width:"41%"}}>
			<RHookFormNumberFieldWithLabel
				label="Max."
				id="maximum"
				testId={`maximum`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
		</div>
	);
};
